import styled from "styled-components";

export const TabsNavigationWapper = styled.div`
    display: flex;
    gap: 8px;

    padding-block: 8px 3px;
    width: max-content;
`